import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import posthog from "posthog-js";
import MainComponent from "./Components/Routes";
import ScrollToTop from "./Components/Utils/ScrollToTop";
import ErrorBoundary from "./Components/ErrorBoundary";
import { NotificationProvider } from "./Components/TailwindNotification";

// Initialize PostHog if API key is configured
const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

if (POSTHOG_API_KEY) {
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
  });
}

function App() {
  return (
    <NotificationProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <ErrorBoundary>
            <ScrollToTop />
            <MainComponent />
          </ErrorBoundary>
        </BrowserRouter>
      </ErrorBoundary>
    </NotificationProvider>
  );
}

export default App;
